<template>
  <router-link class="root-link" to="/">
    <img src="@/assets/error-404.png" />
  </router-link>
</template>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'NotFound'
  });
</script>

<style lang="scss" scoped>
  @use '@/styles/modules/palette';

  .root-link {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: palette.$primary9-color;
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
